import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-discover-ednuv',
  templateUrl: './discover-ednuv.component.html',
  styleUrls: ['./discover-ednuv.component.scss']
})
export class DiscoverEdnuvComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
